const Logo = ({ compact = false, onDark = false }) => (
  <span className="flex items-center" data-testid="nav-brand-logo">
    {onDark ? (
      <span className="rounded-xl bg-cream p-1.5">
        <img src="/logo.webp" alt="Riaas Collective" className={`${compact ? "h-8 w-8" : "h-10 w-10"} object-contain`} />
      </span>
    ) : (
      <img
        src="/logo.webp"
        alt="Riaas Collective"
        className={`${compact ? "h-10 w-10" : "h-14 w-14"} object-contain mix-blend-multiply`}
      />
    )}
  </span>
);

export default Logo;
